import { ObjectHelper } from './ObjectHelper';

export class FlagStatusHelper {

    public static IsSeen(flagStatus: number) : boolean {
        if(ObjectHelper.IsNotNullAndUndefined(flagStatus)) {
            return (flagStatus & 1) == 1;
        }
        return false;
    }

    public static SetIsSeen(flagStatus: number, value: boolean) {
        if(ObjectHelper.IsNotNullAndUndefined(flagStatus)) {
            if(value) {
                return ((flagStatus || 0) | 1);
            }
            else {
                return ((flagStatus || 0) & ~1)
            }
        }
    }

    public static IsAnswered(flagStatus: number) : boolean {
        if(ObjectHelper.IsNotNullAndUndefined(flagStatus)) {
            return (flagStatus & 2) == 2;
        }
        return false;
    }

    public static IsFlagged(flagStatus: number) : boolean {
        if(ObjectHelper.IsNotNullAndUndefined(flagStatus)) {
            return (flagStatus & 4) == 4;
        }
        return false;
    }

    public static SetIsFlagged(flagStatus: number, value: boolean){
        if(ObjectHelper.IsNotNullAndUndefined(flagStatus)) {
            if(value) {
                return ((flagStatus || 0) | 4);
            }
            else {
                return ((flagStatus || 0) & ~4)
            }
        }
    }

    public static IsDeleted(flagStatus: number) : boolean {
        if(ObjectHelper.IsNotNullAndUndefined(flagStatus)) {
            return (flagStatus & 8) == 8;
        }
        return false;
    }

    public static IsDraft(flagStatus: number) : boolean {
        if(ObjectHelper.IsNotNullAndUndefined(flagStatus)) {
            return (flagStatus & 16) == 16;
        }
        return false;
    }

    public static SetIsDraft(flagStatus: number, value: boolean) {
        if(ObjectHelper.IsNotNullAndUndefined(flagStatus)) {
            if(value) {
                return ((flagStatus || 0) | 16);
            }
            else {
                return ((flagStatus || 0) & ~16)
            }
        }
    }    
}